import React, {Component, PureComponent} from 'react';
import styled from "styled-components";

const EditWrapper = styled.div`
    display: inline-block;
    vertical-align: top;
`;

const SelectPrompt = styled.div`
    display: inline-block;
    vertical-align: top;
    font-size: 1.5rem;
    color:lightgrey;
    padding: 0.5rem;
    margin: 0.5rem;
`;

const EditContentWrapper = styled.div`
    display: inline-block;
    vertical-align: top;
    font-size: 1.5rem;
    color:lightgrey;
`;

const EditExploreNameWrapper = styled.div`
    display: inline-block;
    margin: 1.5rem;
`;

const ExploreNameInput = styled.input`
    display: inline-block;
    margin: 0.25rem 1rem;
    padding: 0.5rem;
    width: 25rem;
    font-size: 1.15rem;
    color: #aaaaaa;
    border-radius: 0.35rem
`;

class EditSelectPrompt extends PureComponent {
    render() {
        return <SelectPrompt>Select or Create a Path to Begin</SelectPrompt>
    }
}

class EditExploreName extends Component {
    render () {
        console.log(this.props.explore);
        return <EditExploreNameWrapper>
            <ExploreNameInput value={this.props.explore.name} />
        </EditExploreNameWrapper>;
    }
}

class EditContent extends Component {

    state = {
        explore: null
    }

    componentDidMount() {
        this.loadExplore();
    };

    loadExplore() {
        const hostname = 'http://' + this.props.parsed.hostname + '/fracto/explore?nodeId=' + this.props.nodeId;
        fetch(hostname)
            .then(response => response.json())
            .then(data => this.setState({explore: data.explore}));
    }

    render() {
        const editContents = this.state.explore === null ? "loading..." :
            <EditExploreName explore={this.state.explore} />
        return <EditContentWrapper>
            {editContents}
        </EditContentWrapper>
    }
}

export class ExploreEdit extends PureComponent {
    render() {
        const editContent = this.props.nodeId ? <EditContent {...this.props} nodeId={this.props.nodeId}/> : <EditSelectPrompt/>
        return <EditWrapper>{editContent}</EditWrapper>;
    }
}

export default ExploreEdit;
